import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Button from "../../../shared/button";
import LoginForm from "./login-form";
import ForgotPassword from "./modal/ForgotPasswordModal";


const Login = () => {
    const navigate = useNavigate()
    const [showForgotPasswordModal, setShowForgotPasswordModal] = useState<boolean>(false)

    const onShowHideForgotPassword = () => {
        setShowForgotPasswordModal(!showForgotPasswordModal)
    }

    return (
        <div className="md:min-h-screen px-10 py-12">
            <NavLink to="/">
                {/* Logo here */}
                {/* <img className="max-w-[290px]" alt="for the earth" src="/logo/logo.svg" /> */}
            </NavLink>
            <div className="max-w-[330px] m-auto mt-[9%]">
                <h1 className="font-dm_sans_bold text-4xl">Please fill your details</h1>
                <LoginForm />
                <div className="font-dm_sans_regular text-center flex flex-col items-center mt-8">
                    <Button
                        label={'Forgot your password?'}
                        className={'btn-primary-text !font-normal'}
                        onClickButton={onShowHideForgotPassword}
                    />
                    <div className="my-5 min-w-[70%] border border-borderColor"></div>
                    <Button
                        label={'I don’t have an account.'}
                        className={'btn-primary-text !font-normal'}
                        onClickButton={() => navigate('/register')}
                    />
                </div>
            </div>
            <ForgotPassword
                openForgotModal={showForgotPasswordModal}
                handleCloseForgotModal={onShowHideForgotPassword}
            />
        </div>
    )
}

export default Login;